import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next"
import './go.css'
import SimpleViewBooking from '../../components/utils/simpleViewBooking'
import { ExtensionForm } from 'src/components/genericEntity/entity/ExtensionForm'

import { M_Button, M_MessageBoard, M_Fieldset, LoadingContext, BufferService, LoadingBar, NavigateContext } from 'src/M_Components'

export default function ViewBooking({ handleTabClose, toastMessages }) {
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()
    const [defaultBooking, setDefaultBooking] = useState(false)
    const [isLoaded, setIsLoaded] = useState(true)
    const [voyageDict, setVoyageDict] = useState(new Map())
    const [entitiesDict, setEntitiesDict] = useState(new Map())
    const [locationsDict, setLocationsDict] = useState(new Map())
    // const [detailsDict, setDetailsDict] = useState(new Map())
    const [extraValues, setExtraValues] = useState(new Map())
    const [equipmentClass, setEquipmentClass] = useState('')
    const [adminDict, setAdminDict] = useState(new Map())
    const isAdmin = JSON.parse(sessionStorage.getItem('userRoleNames') || '[]').some(n => n === 'Admin' || n === 'SuperAdmin')

    const [shipmentObjArray, setShipmentObjArray] = useState([])
    const [bookingEquipmentArray, setBookingEquipmentArray] = useState([])
    const [shipmentChargesArray, setShipmentChargesArray] = useState([])

    const [formVoyage, setFormVoyage] = useState(true)
    const [formEntities, setFormEntities] = useState(false)
    const [formPortsLocations, setFormPortsLocations] = useState(false)
    // const [formDetails, setFormDetails] = useState(false)
    const [formEquipments, setFormEquipments] = useState(false)

    //user states
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [bookingDate, setBookingDate] = useState("")
    const [approveDate, setApproveDate] = useState("")
    const [containerDate, setContainerDate] = useState("")
    const [listErrors, setListErrors] = useState('')


    const lineId = JSON.parse(sessionStorage.getItem('bookingLine')) ? JSON.parse(sessionStorage.getItem('bookingLine')).Id : null
    const bookingV2Service = new BufferService('viewbooking')
    const processStatusService = new BufferService('processStatus')
    const auditService = new BufferService('audit/lastbooking')
    const bookingDeleteService = new BufferService('viewbooking/delete')
    const errorList = new BufferService('viewbookingerrors')

    const containerEquipmentTypeService = new BufferService('EquipmentType', 'secondary')
    const containerEquipmentService = new BufferService('Equipment', 'secondary')
    const bookingEquipmentServiceLocal = new BufferService('BookingEquipment');
    const shipmentChargesService = new BufferService('ShipmentCharges')

    const [openDrawer, setOpenDrawer] = useState(false)
    const [selectedLine, setSelectedLine] = useState(null) //guardar
    const [changedList, setChangedList] = useState([])

    const [operation, setOperation] = useState(sessionStorage.getItem('operation'))
    const [openConfirm, setOpenConfirm] = useState(false)
    sessionStorage.removeItem('operation')

    const [drawerName, setDrawerName] = useState('')

    const [leavingPage, setLeavingPage] = useState(false)

    const valueTimeline = [
        { icon: 'pi pi-circle-fill', name: t("TimeLineCreatBook"), color: 'white', connectorColor: 'var(--color-blue)', date: bookingDate },
        { icon: `${approveDate ? 'pi pi-circle-fill' : 'pi pi-spin pi-spinner'}`, name: t("TimeLineBookAccp"), color: 'white', connectorColor: 'var(--color-blue)', date: approveDate },
        { icon: `${containerDate ? 'pi pi-circle-fill' : 'pi pi-spin pi-spinner'}`, name: t("TimeLineInsCont"), color: 'white', connectorColor: 'var(--color-blue)', date: containerDate },
        { icon: 'pi pi-circle', name: t("TimeLineCreBL"), color: 'white', connectorColor: 'var(--color-blue)', date: '' },
        { icon: 'pi pi-circle', name: t("TimeLineBLAccep"), color: 'White', connectorColor: 'var(--color-blue-light)', date: '' }
    ]

    const cards = [
        { id: 1, name: t("Voyage") },
        { id: 2, name: t("Entities") },
        // { id: 3, name: t("PortsAndLocations") },
        { id: 3, name: t("Ports") },
        // { id: 4, name: t("Details") },
        { id: 5, name: t("Equipments") }
    ]

    const extraValuesArray = [
        { label: 'transport id', create: 'TransportId', edit: 'TransportId' },
        { label: 'Original Port id', create: 'LocationReceiptId', edit: 'LocationReceiptId' },
        { label: 'Loading Port id', create: 'LoadingPortId', edit: 'LoadingId' },
        { label: 'Discharge Port id', create: 'DischargePortId', edit: 'DischargeId' },
        { label: 'Final Port id', create: 'LocationDeliveryPortId', edit: 'LocationDeliveryId' },
        { label: 'Client id', create: 'ClientId', edit: 'ClientId' },
        { label: 'Waiting for Approval id', create: 'ProcessStatusId', edit: 'ProcessStatusId' },
        { label: 'InvoiceId', create: 'InvoiceId', edit: 'InvoiceId' },
        { label: 'BookingNumber', create: 'BookingNumber', edit: 'BookingNumber' },
    ]

    const fieldsInDrawerEquipment = ['temp', 'Prefix', 'Number', 'CheckDigit', 'Payload', 'Tare', 'onOff', 'DimensionsWidth', 'DimensionsHeight', 'DimensionsLength', 'Front', 'Back', 'Right', 'Left', 'Height', 'Brand', 'Model', 'Chassis',]
    const fieldsInDrawerShipment = ['IdCommodity', 'CommodityCode', 'CommodityName', 'IdDangerousGoods', 'FlashPT', 'PackagingGroup']

    const showForm = (n) => {
        switch (n) {
            case 1:
                setFormVoyage(true)
                setFormEntities(false)
                setFormPortsLocations(false)
                // setFormDetails(false)
                setFormEquipments(false)
                break
            case 2:
                setFormVoyage(false)
                setFormEntities(true)
                setFormPortsLocations(false)
                // setFormDetails(false)
                setFormEquipments(false)
                break
            case 3:
                setFormVoyage(false)
                setFormEntities(false)
                setFormPortsLocations(true)
                // setFormDetails(false)
                setFormEquipments(false)
                break
            case 4:
                setFormVoyage(false)
                setFormEntities(false)
                setFormPortsLocations(false)
                // setFormDetails(true)
                setFormEquipments(false)
                break
            case 5:
                setFormVoyage(false)
                setFormEntities(false)
                setFormPortsLocations(false)
                // setFormDetails(false)
                setFormEquipments(true)
                break
            default:
                return null
        }
    }

    const sessionKeys = ['defaultBooking', 'voyageDict', 'entitiesDict', 'locationsDict', 'extraValues', 'shipmentObjArray', 'bookingEquipmentArray', 'shipmentChargesArray', 'bookingDate', 'formVoyage', 'formEntities', 'formPortsLocations', 'formEquipments', 'approveDate', 'containerDate', 'changedList', 'operation', 'listErrors', 'adminDict']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            sessionStorage.removeItem('bookingLine')
            sessionStorage.removeItem('operation')
            getSessionStorageData(id)
            setIsFirstLoop(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
        }
        // eslint-disable-next-line
    }, [])

    // eslint-disable-next-line
    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, voyageDict, defaultBooking, entitiesDict, locationsDict, extraValues, shipmentObjArray, bookingEquipmentArray, shipmentChargesArray, bookingDate, formVoyage, formEntities, formPortsLocations, formEquipments, approveDate, containerDate, changedList, operation, listErrors, adminDict])

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const TempDB = JSON.parse(sessionStorage.getItem(`${sessionID}defaultBooking`))
        const TempVD = JSON.parse(sessionStorage.getItem(`${sessionID}voyageDict`))
        const TempED = JSON.parse(sessionStorage.getItem(`${sessionID}entitiesDict`))
        const TempLD = JSON.parse(sessionStorage.getItem(`${sessionID}locationsDict`))
        const TempEV = JSON.parse(sessionStorage.getItem(`${sessionID}extraValues`))
        const TempSOA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentObjArray`))
        const TempBDT = JSON.parse(sessionStorage.getItem(`${sessionID}bookingDate`))
        const TempAD = JSON.parse(sessionStorage.getItem(`${sessionID}approveDate`))
        const TempCD = JSON.parse(sessionStorage.getItem(`${sessionID}containerDate`))

        const frmVoyage = JSON.parse(sessionStorage.getItem(`${sessionID}formVoyage`))
        const frmEntities = JSON.parse(sessionStorage.getItem(`${sessionID}formEntities`))
        const frmPortsLocations = JSON.parse(sessionStorage.getItem(`${sessionID}formPortsLocations`))
        // const frmDetails = JSON.parse(sessionStorage.getItem(`${sessionID}formDetails`))
        const frmEquipments = JSON.parse(sessionStorage.getItem(`${sessionID}formEquipments`))

        const tempCL = JSON.parse(sessionStorage.getItem(`${sessionID}changedList`))
        const TempBEA = JSON.parse(sessionStorage.getItem(`${sessionID}bookingEquipmentArray`))
        const TempSCA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentChargesArray`))
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempLE = JSON.parse(sessionStorage.getItem(`${sessionID}listErrors`))
        const TempADM = JSON.parse(sessionStorage.getItem(`${sessionID}adminDict`))

        // if (frmVoyage || frmEntities || frmPortsLocations || frmDetails || frmEquipments) {
        if (TempDB || TempVD || TempED || TempLD || TempEV || TempSOA || TempBDT || frmVoyage || frmEntities || frmPortsLocations || frmEquipments || TempAD || TempCD|| tempCL || tempO || tempLE) {
            setVoyageDict(new Map(TempVD))
            setDefaultBooking(TempDB)
            setEntitiesDict(new Map(TempED))
            setLocationsDict(new Map(TempLD))
            setExtraValues(new Map(TempEV))
            setShipmentObjArray(TempSOA)
            setBookingDate(TempBDT)
            setApproveDate(TempAD)
            setContainerDate(TempCD)
            if (TempBEA) setBookingEquipmentArray(TempBEA)
            if (TempSCA) setShipmentChargesArray(TempSCA)
            if (TempADM) setAdminDict(new Map(TempADM))
            setFormVoyage(frmVoyage)
            setFormEntities(frmEntities)
            setFormPortsLocations(frmPortsLocations)
            // setFormDetails(frmDetails)
            setFormEquipments(frmEquipments)
            setChangedList(tempCL)
            setOperation(tempO)
            setListErrors(tempLE)
            ctx.setIsLoad(false)
            setIsLoaded(false)
            return
        }
        get()
    }

    function toJSONLocal(date) {
        return date.slice(0, 10)
    }

    function reformatDate(dateStr) {
        var dArr = dateStr.split("-")  // ex input: "2010-01-18"
        return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/2010"
    }

    const get = () => {
        bookingV2Service.getId(lineId).then(data => {
            if (data.name === 'AxiosError') {
                handleTabClose(JSON.parse(id))
                toastMessages('error', data.message, '')
                ctx.setIsLoad(false)
                return
            }
            const dataBooking = data.Booking

            addValue('QuoteName', data.Booking.QuoteName, extraValues, setExtraValues)

            auditService.getId(lineId).then(audit => {
                const tempMap = new Map(Object.entries(audit)) || new Map()
                tempMap.set('0', [])
                // console.log("dataBooking", dataBooking)

                errorList.getId(lineId).then(dataErrorList => {
                    if (dataErrorList.name === 'AxiosError') {
                        toastMessages('error', dataErrorList.message, '')
                        handleTabClose(JSON.parse(id))
                        ctx.setIsLoad(false)
                        return
                    }
                    setListErrors(dataErrorList)
                })

                if (dataBooking.CreatedOn !== "") {
                    const tempDate = reformatDate(toJSONLocal(dataBooking.CreatedOn))
                    setBookingDate(tempDate)
                }

                if (dataBooking.DateApproved !== "") {
                    const tempDate2 = toJSONLocal(dataBooking.DateApproved)
                    setApproveDate(tempDate2)
                }

                if (dataBooking.ContainerInsertedDate && dataBooking.ContainerInsertedDate !== "") {
                    const tempDate3 = toJSONLocal(dataBooking.ContainerInsertedDate)
                    setContainerDate(tempDate3)
                }

                voyage.forEach(obj => {
                    addValue(obj.label, dataBooking[obj.code], voyageDict, setVoyageDict)
                })
                entities.forEach(obj => {
                    addValue(obj.label, dataBooking[obj.code], entitiesDict, setEntitiesDict)
                })
                portsLocations.forEach(obj => {
                    //console.log(obj)
                    if (obj.type === 'checkbox' && !(dataBooking[obj.code] === true || dataBooking[obj.code] === false)) {
                        if (dataBooking[obj.code] === 'Y' || dataBooking[obj.code] === 'S') {
                            addValue(obj.label, true, locationsDict, setLocationsDict)
                        } else {
                            addValue(obj.label, false, locationsDict, setLocationsDict)
                        }
                    } else {
                        addValue(obj.label, dataBooking[obj.name], locationsDict, setLocationsDict)
                    }
                })
                extraValuesArray.forEach(obj => {
                    addValue(obj.label, dataBooking[obj.edit], extraValues, setExtraValues)
                    addValue('id', lineId, extraValues, setExtraValues)
                })
                if (isAdmin) {
                    const newAdminDict = new Map()
                    newAdminDict.set('TradeBound', dataBooking.TradeBound || '')
                    newAdminDict.set('ShipperId', dataBooking.ShipperId || null)
                    newAdminDict.set('ShipperCode', dataBooking.ShipperCode || '')
                    newAdminDict.set('ConsigneeId', dataBooking.ConsigneeId || null)
                    newAdminDict.set('ConsigneeCode', dataBooking.ConsigneeCode || '')
                    newAdminDict.set('NotifyId', dataBooking.NotifyId || null)
                    newAdminDict.set('NotifyCode', dataBooking.NotifyCode || '')
                    newAdminDict.set('SubAccountId', dataBooking.SubAccountId || null)
                    newAdminDict.set('SubAccountCode', dataBooking.SubAccountCode || '')
                    newAdminDict.set('ExternalLineId', dataBooking.ExternalLineId || null)
                    newAdminDict.set('ExternalLineCode', dataBooking.ExternalLineCode || '')
                    newAdminDict.set('AgentId', dataBooking.AgentId || null)
                    newAdminDict.set('AgentCode', dataBooking.AgentCode || '')
                    newAdminDict.set('CurrencyId', dataBooking.CurrencyId || null)
                    newAdminDict.set('CurrencyCode', dataBooking.CurrencyCode || '')
                    newAdminDict.set('IncotermsId', dataBooking.IncotermsId || null)
                    newAdminDict.set('IncotermsCode', dataBooking.IncotermsCode || '')
                    newAdminDict.set('ShippingConditionId', dataBooking.ShippingConditionId || null)
                    newAdminDict.set('ShippingConditionCode', dataBooking.ShippingConditionCode || '')
                    newAdminDict.set('Mrn', dataBooking.Mrn || '')
                    newAdminDict.set('DocumentQuantity', dataBooking.DocumentQuantity ?? null)
                    newAdminDict.set('BLNumber', dataBooking.BLNumber || '')
                    newAdminDict.set('PreCarriageId', dataBooking.PreCarriagePortId || null)
                    newAdminDict.set('PreCarriageName', dataBooking.PreCarriagePortName || '')
                    newAdminDict.set('OnCarriageId', dataBooking.OnCarriagePortId || null)
                    newAdminDict.set('OnCarriageName', dataBooking.OnCarriagePortName || '')
                    newAdminDict.set('SecondTransportId', dataBooking.SecondTransportId || null)
                    newAdminDict.set('SecondVoyageNumber', dataBooking.SecondVoyageNumber || '')
                    newAdminDict.set('SecondVesselCode', dataBooking.SecondVesselCode || '')
                    newAdminDict.set('SecondTradeLineCode', dataBooking.SecondTradeLineCode || '')
                    newAdminDict.set('SecondTradeCode', dataBooking.SecondTradeCode || '')
                    newAdminDict.set('SecondTradeName', dataBooking.SecondTradeName || '')
                    newAdminDict.set('SecondTradeBound', dataBooking.SecondTradeBound || '')
                    newAdminDict.set('CustomStatusId', dataBooking.CustomStatusId || null)
                    newAdminDict.set('CustomStatusCode', dataBooking.CustomStatusCode || '')
                    setAdminDict(newAdminDict)
                }
                let tempEquipmentIndex = 1
                let tempEquipmentIndexes = new Map()
                // let tempShipmentArray = []
                let tempArrayObj = []
                let masterIndex = 0
                data.ShipmentPlusList.forEach((shipments, shipIndex) => {

                    shipments.ShipmentDetailPlusList.forEach((shipmentsDetails, index) => {
                        const bookingEquipment = shipmentsDetails.BookingEquipment
                        const isBookingEquipment = bookingEquipment && (bookingEquipment.IdParkLocation || bookingEquipment.IdTerminalLoadLocation || bookingEquipment.IdTerminalDischargeLocation || bookingEquipment.BookingDate || bookingEquipment.GateDate)
                        if (isBookingEquipment) return

                        tempEquipmentIndex++
                        let tempToUseEquipmentIndex = tempEquipmentIndex
                        let tempEquipment = 'yes'

                        if (!tempEquipmentIndexes.get(shipmentsDetails.BookingEquipment.Id)) {
                            tempEquipmentIndexes.set(shipmentsDetails.BookingEquipment.Id, tempToUseEquipmentIndex)
                        } else {
                            tempToUseEquipmentIndex = tempEquipmentIndexes.get(shipmentsDetails.BookingEquipment.Id)
                            tempEquipment = 'no'
                        }
                        masterIndex++
                        setEquipmentClass(shipmentsDetails.EquipmentClass?.EquipmentCode || '')
                        let tempObj = {
                            'id': masterIndex,
                            'Quantity': '1',
                            'shipOrder': shipments.Shipment.Order,
                            'shipTransOrder': shipments.Shipment.TransportKey,
                            'ShipmentId': shipments.Shipment.Id,
                            'ShipmentDetailsId': shipmentsDetails.ShipmentDetail.Id,
                            'bookingEquipmentId': shipmentsDetails.BookingEquipment.Id,
                            'EquipmentTransportKey': shipmentsDetails.BookingEquipment.TransportKey,
                            'EquipmentIndex': tempToUseEquipmentIndex,
                            'EquipmentTypeId': shipmentsDetails.EquipmentType?.Id || shipmentsDetails.BookingEquipment?.ContainerControlEquipmentTypeId || shipmentsDetails.BookingEquipment?.IdEquipmentType || '',
                            'Equipment Type': `${shipmentsDetails.EquipmentType?.EquipmentTypeCode || ''}`,
                            'EquipmentClassCode': shipmentsDetails?.EquipmentClass?.EquipmentCode || '',
                            // 'Cargo Description': shipmentsDetails.ShipmentDetail.Description ? shipmentsDetails.ShipmentDetail.Description : '',
                            'Cargo Description': shipmentsDetails.BookingEquipment.GoodsDetails ? shipmentsDetails.BookingEquipment.GoodsDetails : '',
                            // 'Load Weight (KG)': shipmentsDetails.ShipmentDetail.Weight ? shipmentsDetails.ShipmentDetail.Weight : '',
                            'Load Weight (KG)': shipmentsDetails.BookingEquipment.TransportDetails ? shipmentsDetails.BookingEquipment.TransportDetails : '',
                            'Loading Date': shipmentsDetails.BookingEquipment.LoadingDate?.slice(0, shipmentsDetails.BookingEquipment.LoadingDate.search('T')),
                            'Shipment': shipments.Shipment.TransportKey,
                            'SOC': shipmentsDetails.BookingEquipment.SOC === 'Y' ? true : false,
                            'IMO': shipments.Shipment.IMODangerGoods ? shipments.Shipment.IMODangerGoods : false,
                            'FlashPT': shipments.Shipment.FlashPT,
                            'PackagingGroup': shipments.Shipment.PackingGroup,
                            'Reefer': shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('RF') || shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('HR') || false,
                            'onOff': shipments.Shipment.Temp !== 0 && shipments.Shipment.Temp !== undefined && shipments.Shipment.Temp !== null ? true : false,
                            'temp': shipments.Shipment.Temp,
                            'Tare': shipmentsDetails?.Equipment?.Tare || shipmentsDetails.EquipmentType?.EquipmentTypeTareWeight || '',
                            'Payload': shipmentsDetails?.Equipment?.Payload || '',
                            'Brand': shipmentsDetails.BookingEquipment.Brand,
                            'Model': shipmentsDetails.BookingEquipment.Model,
                            'Chassis': shipmentsDetails.BookingEquipment.Chassis,
                            'RORO': shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('RORO') || false,
                            'OpenTop': shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('OT') || shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('FL') || false,
                            // 'DangerousGoodsId': shipments?.DangerousGoods?.Id,
                            // 'DangerousGoodsCode': shipments?.DangerousGoods?.Code,
                            // 'DangerousGoodsClass': shipments?.DangerousGoods?.Class,
                            'EquipmentId': shipmentsDetails?.Equipment?.Id,
                            'Prefix': shipmentsDetails?.Equipment?.Prefix,
                            'Number': shipmentsDetails?.Equipment?.Number,
                            'CheckDigit': shipmentsDetails?.Equipment?.CheckDigit,
                            'equipmentNumber': `${shipmentsDetails?.Equipment?.Prefix} ${shipmentsDetails?.Equipment?.Number} ${shipmentsDetails?.Equipment?.CheckDigit}`,
                            'DimensionsId': shipmentsDetails.BookingEquipmentDimensionsList[0]?.Id,
                            'DimensionsWidth': shipmentsDetails.BookingEquipmentDimensionsList[0]?.DimensionsWidth,
                            'DimensionsHeight': shipmentsDetails.BookingEquipmentDimensionsList[0]?.DimensionsHeight,
                            'DimensionsLength': shipmentsDetails.BookingEquipmentDimensionsList[0]?.DimensionsLength,
                            'CommodityCode': shipments.Shipment?.CommodityCode,
                            'CommodityName': shipments.Shipment?.CommodityName,
                            'Equipment': tempEquipment,
                            'shipmentChanged': [...deRetardLabels(tempMap.get(shipments.Shipment.Id || '0') || [], 'Shipment'), ...bookingEquipmentchanges(tempMap.get(shipmentsDetails.BookingEquipment.Id || '0') || []), ...deRetardLabels(tempMap.get(shipmentsDetails?.Equipment?.Id || '0') || []), ...getAllDimensions(shipmentsDetails.BookingEquipmentDimensionsList, tempMap)],
                            'dangerousGoods': shipments.ShipmentDangerousGoodsPlusList.map((imo, imoIndex) => {
                                return {
                                    'id': imoIndex + 1,
                                    'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                                    'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                                    'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                                    'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                                    'DangerousGoodsCode': imo.DangerousGoods.Code,
                                    'DangerousGoodsClass': imo.DangerousGoods.Class,
                                    'shipmentChanged': [...(tempMap.get(imo.ShipmentDangerousGoods.Id || '0') || [])],
                                }
                            })
                        }
                        shipmentsDetails.BookingEquipmentDimensionsList.forEach(dimension => {
                            if (dimension.DimensionsCode === 'FRO') {
                                tempObj.Front = dimension.DimensionsLength || 0
                                tempObj.DimensionsFROId = dimension.Id
                            }
                            if (dimension.DimensionsCode === 'BAC') {
                                tempObj.Back = dimension.DimensionsLength || 0
                                tempObj.DimensionsBACId = dimension.Id
                            }
                            if (dimension.DimensionsCode === 'LEF') {
                                tempObj.Left = dimension.DimensionsWidth || 0
                                tempObj.DimensionsLEFId = dimension.Id
                            }
                            if (dimension.DimensionsCode === 'RIG') {
                                tempObj.Right = dimension.DimensionsWidth || 0
                                tempObj.DimensionsRIGId = dimension.Id
                            }
                            if (dimension.DimensionsCode === 'OVE') {
                                tempObj.Height = dimension.DimensionsHeight || 0
                                tempObj.DimensionsOVEId = dimension.Id
                            }
                        })
                        // if (tempObj.DimensionsId) {
                        //     tempObj.shipmentChanged.push(...(tempMap.get(tempObj.DimensionsId || '0') || []))
                        // }
                        if (tempObj.Equipment === 'no') {
                            const newTempArray = []
                            let tempBool = false
                            tempArrayObj.forEach(obj => {
                                if (obj.EquipmentIndex === tempObj.EquipmentIndex) {
                                    tempBool = true
                                    if (!newTempArray.some(test => test.id === tempObj.id) && obj.id !== tempObj.id) {
                                        newTempArray.push(tempObj)
                                        newTempArray.push(obj)
                                    } else {
                                        newTempArray.push(obj)
                                    }
                                } else {
                                    newTempArray.push(obj)
                                }
                            })
                            if (tempBool === false) {
                                newTempArray.push(tempObj)
                            }
                            tempArrayObj = newTempArray
                        } else {
                            tempArrayObj.push(tempObj)
                        }
                    })
                    if (shipments.ShipmentDetailPlusList.length === 0) {
                        masterIndex++
                        tempEquipmentIndex++
                        const bareObj = {
                            'id': masterIndex,
                            'Quantity': '1',
                            'shipOrder': shipments.Shipment.Order,
                            'shipTransOrder': shipments.Shipment.TransportKey,
                            'ShipmentId': shipments.Shipment.Id,
                            'ShipmentDetailsId': null,
                            'bookingEquipmentId': null,
                            'EquipmentIndex': tempEquipmentIndex,
                            'EquipmentTypeId': '',
                            'Equipment Type': '',
                            'Shipment': shipments.Shipment.TransportKey,
                            'IMO': shipments.Shipment.IMODangerGoods || false,
                            'FlashPT': shipments.Shipment.FlashPT,
                            'PackagingGroup': shipments.Shipment.PackingGroup,
                            'temp': shipments.Shipment.Temp,
                            'onOff': shipments.Shipment.Temp !== 0 && shipments.Shipment.Temp !== undefined && shipments.Shipment.Temp !== null,
                            'CommodityCode': shipments.Shipment?.CommodityCode,
                            'CommodityName': shipments.Shipment?.CommodityName,
                            'Equipment': 'yes',
                            'shipmentChanged': [...deRetardLabels(tempMap.get(shipments.Shipment.Id || '0') || [], 'Shipment')],
                            'dangerousGoods': shipments.ShipmentDangerousGoodsPlusList.map((imo, imoIndex) => ({
                                'id': imoIndex + 1,
                                'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                                'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                                'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                                'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                                'DangerousGoodsCode': imo.DangerousGoods.Code,
                                'DangerousGoodsClass': imo.DangerousGoods.Class,
                                'shipmentChanged': [...(tempMap.get(imo.ShipmentDangerousGoods.Id || '0') || [])],
                            }))
                        }
                        tempArrayObj.push(bareObj)
                    }
                })
                //? FALAR COM O RODRIGO
                tempArrayObj.sort((a, b) => a.shipOrder === b.shipOrder ? a.shipTransOrder - b.shipTransOrder : a.shipOrder - b.shipOrder)
                // tempArrayObj.sort((a, b) => a.shipTransOrder - b.shipTransOrder)

                //    console.log( )
                // tempArrayObj = tempArrayObj.sort((a, b) => a.shipTransOrder - b.shipTransOrder)
                setShipmentObjArray(tempArrayObj)

                // Fetch EquipmentType from ContainerControl for Shipments
                const ccShipmentPromises = [];
                tempArrayObj.forEach((shipmentItem, index) => {
                    if (shipmentItem.EquipmentTypeId && 
                        shipmentItem.EquipmentTypeId !== '00000000-0000-0000-0000-000000000000' &&
                        (!shipmentItem['Equipment Type'] || shipmentItem['Equipment Type'] === '')) {
                        
                        const promise = containerEquipmentTypeService
                            .filter(`/byExternalId/${shipmentItem.EquipmentTypeId}`)
                            .then(response => {
                                const ccType = Array.isArray(response) ? response[0] : response;
                                if (ccType && ccType.name !== 'AxiosError') {
                                    setShipmentObjArray(prev => {
                                        const newArr = [...prev];
                                        if (newArr[index]) {
                                            newArr[index] = {
                                                ...newArr[index],
                                                'Equipment Type': ccType.Code || '',
                                                'EquipmentTypeCode': ccType.Code || '',
                                                'EquipmentTypeId': shipmentItem.EquipmentTypeId,
                                            };
                                        }
                                        return newArr;
                                    });
                                }
                            })
                            .catch(() => {});
                        ccShipmentPromises.push(promise);
                    }
                });

                // Load BookingEquipments
                const bookingId = lineId;

                bookingEquipmentServiceLocal.filter(`/byBooking/${bookingId}`).then(response => {
                    const items = Array.isArray(response) ? response : (response.Items || []);

                    const meaningful = (items || []).filter(be =>
                        be.EquipmentId ||
                        be.ContainerControlEquipmentId ||
                        be.IdParkLocation ||
                        be.IdTerminalLoadLocation ||
                        be.IdTerminalDischargeLocation ||
                        be.BookingDate ||
                        be.GateDate
                    )
                    if (meaningful.length > 0) {
                        const mappedBE = meaningful.map((be, idx) => ({
                            id: idx + 1,
                            Shipment: be.ShipmentTransportKey || 1,
                            EquipmentIndex: idx + 1,

                            EquipmentTypeId: be.ContainerControlEquipmentTypeId ?? be.EquipmentTypeId,
                            EquipmentId: be.ContainerControlEquipmentId ?? be.EquipmentId,

                            EquipmentType: `${be.EquipmentTypeLenght || ''}${be.EquipmentTypeCode || ''}`,
                            EquipmentTypeCode: be.EquipmentTypeCode || '',
                            EquipmentNumber: '',

                            ParkCode: be.ParkLocationCode || '',
                            ParkCodeId: be.IdParkLocation || null,
                            TerminalLoadLocation: be.TerminalLoadLocationCode || '',
                            TerminalLoadLocationId: be.IdTerminalLoadLocation || null,
                            TerminalDischargeLocation: be.TerminalDischargeLocationCode || '',
                            TerminalDischargeLocationId: be.IdTerminalDischargeLocation || null,

                            BookingDate: be.BookingDate || '',
                            GateDate: be.GateDate || '',
                        }));

                        setBookingEquipmentArray(mappedBE);
        
                        // Fetch data from ContainerControl that don't have local info
                        const ccPromises = [];
                        mappedBE.forEach((beItem, index) => {
                            if (!beItem.EquipmentType && beItem.EquipmentTypeId) {
                                const promise = containerEquipmentTypeService
                                    .filter(`/byExternalId/${beItem.EquipmentTypeId}`)
                                    .then(response => {
                                        const ccType = Array.isArray(response) ? response[0] : response;
                                        if (ccType && ccType.name !== 'AxiosError') {
                                            setBookingEquipmentArray(prev => {
                                                const newArr = [...prev];
                                                if (newArr[index]) {
                                                    newArr[index] = {
                                                        ...newArr[index],
                                                        EquipmentType: `${ccType.Code || ''}`,
                                                        EquipmentTypeCode: ccType.Code || '',
                                                    };
                                                }
                                                return newArr;
                                            });
                                        }
                                    })
                                    .catch(() => {});
                                ccPromises.push(promise);
                            }
            
                            // If don't have EquipmentNumber but have EquipmentId
                            if (!beItem.EquipmentNumber && beItem.EquipmentId) {
                                const promise = containerEquipmentService
                                    .filter(`/byExternalId/${beItem.EquipmentId}`)
                                    .then(response => {
                                        const ccEquip = Array.isArray(response) ? response[0] : response;
                                        if (ccEquip && ccEquip.name !== 'AxiosError') {
                                            setBookingEquipmentArray(prev => {
                                                const newArr = [...prev];
                                                if (newArr[index]) {
                                                    newArr[index] = {
                                                        ...newArr[index],
                                                        EquipmentNumber: `${ccEquip.Prefix || ''} ${ccEquip.Number || ''} ${ccEquip.CheckDigit || ''}`,
                                                        Prefix: ccEquip.Prefix || '',
                                                        Number: ccEquip.Number || '',
                                                        CheckDigit: ccEquip.CheckDigit || ''
                                                    };
                                                }
                                                return newArr;
                                            });
                                        }
                                    })
                                    .catch(() => {});
                                ccPromises.push(promise);
                            }
                        });
        
                    } else {
                        setBookingEquipmentArray([]);
                    }
                }).catch(() => {
                    setBookingEquipmentArray([]);
                });

                ctx.setIsLoad(false)
                setIsLoaded(false)
                let approved = ''
                let reject = ''
                processStatusService.get().then(dataProcessStatusService => {
                    if (dataProcessStatusService.name === 'AxiosError') {
                        toastMessages('error', dataProcessStatusService.message, '')
                        return
                    }
                    dataProcessStatusService.Items.forEach(dataStatus => {
                        if (dataStatus.StatusName === 'Approved') {
                            approved = dataStatus.Id
                            //   setApproved(approved)
                        }
                        if (dataStatus.StatusName === 'Rejected') {
                            reject = dataStatus.Id
                            //   setApproved(reject)
                        }
                    })
                    wasEdited([...(tempMap.get(data.Booking.Id || '0') || [])])
                })
            })
        })
    }

    const getAllDimensions = (dimensions, changesMap) => {
        if (dimensions.length > 1) {
            const newArray = []
            dimensions.forEach(elem => {
                if (elem.DimensionsCode === 'FRO') {
                    if (changesMap?.get(elem.Id)?.includes('DimensionsLength')) newArray.push('Front')
                }
                if (elem.DimensionsCode === 'BAC') {
                    if (changesMap?.get(elem.Id)?.includes('DimensionsLength')) newArray.push('Back')
                }
                if (elem.DimensionsCode === 'LEF') {
                    if (changesMap?.get(elem.Id)?.includes('DimensionsWidth')) newArray.push('Left')
                }
                if (elem.DimensionsCode === 'RIG') {
                    if (changesMap?.get(elem.Id)?.includes('DimensionsWidth')) newArray.push('Right')
                }
                if (elem.DimensionsCode === 'OVE') {
                    if (changesMap?.get(elem.Id)?.includes('DimensionsHeight')) newArray.push('Height')
                }
            })
            return newArray
        }
        if (dimensions.length === 1) {
            return changesMap.get(dimensions[0].Id) || []
        }
        if (dimensions.length === 0) {
            return []
        }
        return []
    }

    const bookingEquipmentchanges = (newList) => {
        const tempList = []
        newList.forEach(el => {
            switch (el) {
                case 'Id':
                    tempList.push('bookingEquipmentId')
                    break
                case 'GoodsDetails':
                    tempList.push('Cargo Description')
                    break
                case 'TransportDetails':
                    tempList.push('Load Weight (KG)')
                    break
                case 'LoadingDate':
                    tempList.push('Loading Date')
                    break
                case 'IMODangerGoods':
                    tempList.push('IMO')
                    break
                case 'Temp':
                    tempList.push('temp')
                    break
                default:
                    tempList.push(el)
            }
        })
        return tempList
    }

    const deRetardLabels = (newList, type) => {
        const tempList = []
        newList.forEach(el => {
            switch (el) {
                case 'IMODangerGoods':
                    tempList.push('IMO')
                    break
                case 'Temp':
                    tempList.push('temp')
                    break
                default:
                    if (type === 'Shipment' && el === 'Id') {
                        tempList.push('ShipmentId')
                    } else {
                        tempList.push(el)
                    }
            }
        })
        return tempList
    }

    const wasEdited = (newList) => {
        console.log(newList)
        const tempList = []
        newList.forEach(el => {
            tempList.push(el)
        })
        setChangedList(tempList)
    }

    const voyage = [
        { label: 'Vessel', tablecode: 'name', code: 'VesselCode', id: 'TransportId' },
        { label: 'Voyage', tablecode: 'voyageNumber', code: 'VoyageNumber', id: 'TransportId' },
    ]

    const entities = [
        { label: 'Client', tablecode: 'accountCode', code: 'ClientCode', id: 'ClientId' },
        { label: 'Client VAT', tablecode: 'accountVATNumber', code: 'ClientVAT', id: 'ClientId' },
        { label: 'Client Reference', tablecode: 'clientReference', code: 'ClientReference' },
        { label: 'Invoice Entity', tablecode: '', code: 'InvoiceCode', id: 'InvoiceId' },
        { label: 'Invoice VAT', tablecode: '', code: 'InvoiceVat', id: 'InvoiceId' },
    ]

    const portsLocations = [
        { label: 'Original Port', tablecode: 'Name', type: 'textfield', code: 'OriginalPortCode', name: 'LocationReceiptPortName', id: 'LocationReceiptId', },
        { label: 'Loading Port', tablecode: 'Name', type: 'textfield', code: 'LoadingPortCode', name: 'LocationLoadingPortName', id: 'LoadingPortId' },
        { label: 'Discharge Port', tablecode: 'Name', type: 'textfield', code: 'DischargePortCode', name: 'LocationDischargePortName', id: 'DischargePortId' },
        { label: 'Final Port', tablecode: 'Name', type: 'textfield', code: 'FinalPortCode', name: 'LocationDeliveryPortName', id: 'LocationDeliveryPortId' },
        { label: 'Transhipment', tablecode: '', type: 'checkbox', code: 'Transhipment', name: 'Transhipment', },
    ]


    const addValue = (key, value, dict, setDict) => {

        if (typeof value === 'string' || value instanceof String) {
            value = value.toLocaleUpperCase()
        }

        dict.set(key, value)
        setDict(new Map(dict))
    }

    const deleteBooking = () => {
        bookingDeleteService.delete(extraValues.get('id')).then(data => {
            if (data.name === "AxiosError") {
                ctx.toastMessages('error', '', data.response.data.Message || data.message)
                return
            }
            setOpenConfirm(true)
        })
    }

    const functionLeavingPage = () => {
        ctx2.closeTab(JSON.parse(id))
    }

    const chargesBookingNumber = extraValues.get('BookingNumber') || ''

    useEffect(() => {
        if (chargesBookingNumber) {
            shipmentChargesService.filter(`/queryByBooking?booking_number=${chargesBookingNumber}`)
                .then(data => {
                    if (data && !data.name) {
                        setShipmentChargesArray(Array.isArray(data) ? data : (data?.value || []))
                    }
                })
        } else {
            setShipmentChargesArray([])
        }
        // eslint-disable-next-line
    }, [chargesBookingNumber])

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (
                <>
                    <SimpleViewBooking
                        setShipmentObjArray={setShipmentObjArray}
                        valueTimeline={valueTimeline}
                        setDefaultBooking={setDefaultBooking}
                        voyage={voyage}
                        voyageDict={voyageDict}
                        entities={entities}
                        entitiesDict={entitiesDict}
                        portsLocations={portsLocations}
                        locationsDict={locationsDict}
                        shipmentObjArray={shipmentObjArray}
                        bookingEquipmentArray={bookingEquipmentArray}
                        shipmentChargesArray={shipmentChargesArray}
                        t={t}
                        openDrawer={openDrawer}
                        setOpenDrawer={setOpenDrawer}
                        selectedLine={selectedLine}
                        setSelectedLine={setSelectedLine}
                        changedList={changedList}
                        drawerName={drawerName}
                        setDrawerName={setDrawerName}
                        extraValues={extraValues}
                        operation={operation}
                        deleteBooking={deleteBooking}
                        leavingPage={leavingPage}
                        setLeavingPage={setLeavingPage}
                        functionLeavingPage={functionLeavingPage}
                        ctx={ctx}
                        fieldsInDrawerEquipment={fieldsInDrawerEquipment}
                        fieldsInDrawerShipment={fieldsInDrawerShipment}
                        listErrors={listErrors}
                        isAdmin={isAdmin}
                        adminDict={adminDict}
                    />
                    <div className='divForm'>
                        <M_Fieldset
                            labelInside
                            label={
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <i className="pi pi-box" style={{ marginRight: '10px' }} />
                                    {t('AdditionalFields')}
                                </span>
                            }
                            elements={
                                <ExtensionForm
                                    extendedEntityId="booking"
                                    extendedItemId={extraValues.get('id') || null}
                                    canEdit={false}
                                />
                            }
                        />
                    </div>
                </>
            )}
            <M_MessageBoard
                open={openConfirm}
                onClose={() => setOpenConfirm(false)}
                title={t('ApproveDeletion')}
                body={t('BookingDeleted')}
                footer={
                    <M_Button
                        normal
                        hoverEffect
                        label={t('Confirm')}
                        backgroundColor={'var(--color-green)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => {
                            setOpenConfirm(false)
                            handleTabClose(JSON.parse(id))
                        }}
                    />
                }
            />
        </>
    )
}